const defaultState = {
  listingAdmins: [],
  adminsFilter: []
};

export default defaultState;
